import * as React from 'react';

const ExclusiveBrandsItem = ({ logoSrc , title , url  })=>/*#__PURE__*/ React.createElement("li", {
        className: "exclusive-brands-item"
    }, /*#__PURE__*/ React.createElement("a", {
        className: "exclusive-brands-item__link",
        href: url
    }, /*#__PURE__*/ React.createElement("img", {
        className: "exclusive-brands-item__image",
        src: logoSrc,
        alt: title
    })))
;
var ExclusiveBrandsItem$1 = /*#__PURE__*/ React.memo(ExclusiveBrandsItem);

export { ExclusiveBrandsItem$1 as default };
//# sourceMappingURL=ExclusiveBrandsItem.js.map
